import React from 'react'
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from 'perfect-scrollbar';
import {
    Route,
    Switch,
    Redirect,
} from 'react-router-dom'

import { Header, Footer, Sidebar } from 'components'

import PropTypes from 'prop-types'

import dashboardRoutes from 'routes/dashboard.jsx'
import getSystemFrontendSettings from '../../lib/systemFrontendSettings'
import Popup from '../../lib/Popup'

// var ps;

class Dashboard extends React.Component {
    componentDidMount() {
        /* if(navigator.platform.indexOf('Win') > -1){
            ps = new PerfectScrollbar(this.refs.mainPanel);
            document.body.classList.toggle("perfect-scrollbar-on");
        } */
    }

    componentWillUnmount() {
        /* if(navigator.platform.indexOf('Win') > -1){
            ps.destroy();
            document.body.classList.toggle("perfect-scrollbar-on");
        } */
    }

    async componentWillMount() {
        await getSystemFrontendSettings()
    }

    componentDidUpdate(e) {
        if (e.history.action === 'PUSH') {
            this.refs.mainPanel.scrollTop = 0
            document.scrollingElement.scrollTop = 0
        }
    }

    render() {
        // return (
        //     <div className="wrapper">
        //         <Header {...this.props} />
        //         <Sidebar {...this.props} routes={dashboardRoutes} />
        //         <div className="main-panel" ref="mainPanel">
        //             <Switch>
        //                 {
        //                     dashboardRoutes.map((prop, key) => {
        //                         if (prop.collapse) {
        //                             return prop.views.map((prop2, key2) => {
        //                                 return (
        //                                     <Route path={prop2.path} component={prop2.component} key={key2} />
        //                                 )
        //                             })
        //                         }
        //                         if (prop.redirect) {
        //                             return (
        //                                 <Redirect from={prop.path} to={prop.pathTo} key={key} />
        //                             )
        //                         }
        //                         return (
        //                             <Route path={prop.path} component={prop.component} key={key} />
        //                         )
        //                     })
        //                 }
        //             </Switch>
        //             <Footer fluid />
        //         </div>
        //         <ChatSidebar {...this.props} routes={dashboardRoutes} />
        //     </div>
        // )
        return (
            <div className="wrapper">
                <Popup history={this.props.history}/>
                <Header {...this.props} />
                <div className="row m-0 w-100" >
                    <Sidebar {...this.props} routes={dashboardRoutes} />
                    <div className="main-panel" ref="mainPanel">
                        <Switch>
                            {
                                dashboardRoutes.map((prop, key) => {
                                    if (prop.collapse) {
                                        return prop.views.map((prop2, key2) => {
                                            return (
                                                <Route path={prop2.path} component={prop2.component} key={key2} />
                                            )
                                        })
                                    }
                                    if (prop.redirect) {
                                        const splittedLink = window.location.href.split('/')
                                        const lastSegment = splittedLink[splittedLink.length - 1]
                                        if (lastSegment) return (<Redirect from={prop.path} to={'/404'} key={key} />)
                                        else return (<Redirect from={prop.path} to={prop.pathTo} key={key} />)
                                    }
                                    return (
                                        <Route path={prop.path} key={key} component={prop.component} />
                                    )
                                })
                            }
                        </Switch>

                    </div>
                </div>
                <Footer {...this.props} fluid />
            </div>
        )
    }
}

Dashboard.propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx